import { createFileRoute } from '@tanstack/react-router';

import { NotFoundContent } from './404';

/**
 * Catch-all route that handles any unmatched paths
 * This ensures SSR works properly for routes that don't have specific route files
 * On the client, unmatched routes will show the 404 page
 */
const CatchAllPage = () => {
  return <NotFoundContent />;
};

export const Route = createFileRoute('/$')({
  component: CatchAllPage,
});
